<template>
  <section id="contact">
    <p class="title">Contact</p>
    <div class="content">
      <vue-markdown
          v-if="body"
          class="body"
          :source="body"
      />     
      <p>And <a id="profilePhotoLink"
                :class="{ strike: !profilePhotoHidden }"
                @click="profilePhotoHidden = !profilePhotoHidden"
              >here</a> is a photo of Pia.
      </p>
      <img 
        id="profilePhoto" 
        :class="{ hidden: profilePhotoHidden }"
        :src="photoSrc" 
        />
      <p 
        v-if="credit"
        id="credit"
        :class="{ hidden: profilePhotoHidden }"
        > {{ credit }}
      </p>
      <p id="impressumLink">
        <a
          :class="{ strike: !impressumHidden }"
          @click="toggleImpressum"
        >
          Impressum
        </a>
      </p>
      <vue-markdown
        id="impressum"
        v-if="impressum"
        :class="{ fadein: !impressumHidden }"
        :source="impressum"
      />  
    </div>
  </section>
</template>

<script>
export default {
  name: "contact",
  props: [
    'body',
    'impressum',
    'photoSrc',
    'credit',
  ],
  data () {
    return {
      profilePhotoHidden: true,
      impressumHidden: true,
    }
  },
  methods: {
    toggleImpressum() {
      this.impressumHidden = !this.impressumHidden
      this.$emit('impressum', this.impressumHidden)
      const impressum = document.getElementById('impressum')
      impressum.addEventListener('wheel', (event) => {
        if (impressum.scrollHeight > impressum.clientHeight) {
          event.stopPropagation()
        }
      })
    }
  }
}
</script>

<style scoped>
section#contact {
  max-width: 350px;
}
#contact div.content {
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: scroll;
}
#contact div.content .body :first-child {
  margin-top: 0;
}
#contact div.content .body :last-child {
  margin-bottom: 0;
}
#profilePhoto {
  max-width: 100%;
  object-fit: contain;
  object-position: top;
  margin-bottom: 10px;
  z-index: 4;
}
#profilePhoto.hidden {
  display: none;
}
#credit {
  margin: 0;
  font-size: 9pt;
  font-style: italic;
}
#credit.hidden {
  display: none;
}
#impressum.fadein {
  flex: 1;
  opacity: 1;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 15px;
  max-height: 1500px;
  transition: all 0.5s ease;
}
#impressum {
  flex: 0;
  overflow-y: scroll;
  border: var(--thin-grey);
  opacity: 0;
  max-height: 0;
  background: var(--palest-yellow);
  transition: all 0.5s ease;
  z-index: 2;
}
#impressumLink {
  padding-bottom: 15px;
  margin-bottom: 0px;
  width: 100%;
  margin-top: auto;
}
</style>


